/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellTemplate/FreeCellInputInterpreter',[
		'absolute/debug',
		'Arkadium/GameEngine/Core/EngineManagers',
		'SolitaireShared/CardLogic/CardAction',
		'SolitaireShared/CardLogic/CardValue',
		'SolitaireShared/CardLogic/CardSuit',
		'CardUI/PileView',
		'util/SettingsManager',
		'SolitaireShared/CardLogic/Pile'],
	function (Debug, EngineManagers, CardAction, CardValue, CardSuit, PileView, SettingsManager, Pile) {
		"use strict";

		var FreeCellInputInterpreter = function (authority) {
			this.initFreeCellInputInterpreter(authority);
		};

		FreeCellInputInterpreter.DoubleClickThreshold = 700;

		FreeCellInputInterpreter.prototype.initFreeCellInputInterpreter = function (authority) {
			this.Authority = authority;

			this.InputEnabled = true;


			this.HighlightedCard = null;
			this.HighlightTime = -1;
		};


		FreeCellInputInterpreter.prototype.Drag = function (cardDragged, distance) {
			if (this.IsCardHighlighted() && distance > 50) {
				this.ClearHighlight();
			}
			return true;
		};

		FreeCellInputInterpreter.prototype.NotifyCardsMoved = function () {
			this.ClearHighlight();
		};

		/// <summary>
		/// Build an action to move a card from one pile to another. Return true if action was built.
		/// </summary>
		FreeCellInputInterpreter.prototype.DoMoveCard = function (card, fromPile, toPile, action) {
			var count = fromPile.GetCardPosFromEnd(card);

			action.Parse(["move", fromPile.Name, toPile.Name, count.toString()]);
		};

		FreeCellInputInterpreter.prototype.Drop = function (cardDropped, dropPiles) {
			//#if WIN8
			var soundHasBeenPlayed = false;
			//#endif
			var supply = cardDropped.Card.Supply;
			var action = new CardAction(supply);
			action.Parse(["noop"]);

			if (!this.InputEnabled) return action;

			for (var i = 0; i < dropPiles.length; i++) {
				var dropPile = dropPiles[i];
				var card = cardDropped.Card;
				var fromPile = card.Pile;
				var toPile = (dropPile instanceof Pile) ? dropPile : dropPile.Pile;

				if (fromPile != toPile) {
					// if we dropped the card to a new pile, clear its highlight.
					// otherwise let it stay highlighted
					this.ClearHighlight();
					this.DoMoveCard(card, fromPile, toPile, action);

					if (action.IsAllowed()) {
						//#if WIN8
						if (toPile.Type == "Foundation") {
							EngineManagers.Sounds.PlaySound("foundation");
							soundHasBeenPlayed = true;
						} else {
							EngineManagers.Sounds.PlaySound("legalMove");
							soundHasBeenPlayed = true;
						}
						//#endif

						break;
					}
				} else
					break;
			}

//#if WIN8
			if (!soundHasBeenPlayed) {
				EngineManagers.Sounds.PlaySound("illegalMove");
			}
//#endif

			return action;
		};

		FreeCellInputInterpreter.TryFoundationPiles = ["Foundation0", "Foundation1", "Foundation2", "Foundation3"];
		FreeCellInputInterpreter.TryFreePiles = ["Free0", "Free1", "Free2", "Free3"];

		FreeCellInputInterpreter.prototype.ClickCard = function (cardClicked, rightClicked, isSingleTap) {
			var supply = cardClicked.Card.Supply;
			var action = new CardAction(supply);
			action.Parse(["noop"]);

			if (!this.InputEnabled || (!cardClicked.IsDraggable && !isSingleTap)) return action;

			if (this.IsCardHighlighted() || rightClicked) {
				if ((this._highlightedCard == cardClicked || rightClicked) && cardClicked.Card.Pile.Type != "Foundation") {

					// check for double-click
					var currentTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
					if ((!SettingsManager.getSetting('default', 'singleTapToMove')) &&
						(rightClicked || currentTime - this._highlightTime < FreeCellInputInterpreter.DoubleClickThreshold)) {
						// double-clicked! find a pile for us
						var foundationPile = null;
						if (cardClicked.Card.Value == CardValue.Values.Ace) {
							// find empty foundation
							switch (cardClicked.Card.Suit) {
								case CardSuit.Hearts:
									foundationPile = this.Authority.CardSupply.GetPile("Foundation0");
									break;
								case CardSuit.Clubs:
									foundationPile = this.Authority.CardSupply.GetPile("Foundation1");
									break;
								case CardSuit.Diamonds:
									foundationPile = this.Authority.CardSupply.GetPile("Foundation2");
									break;
								case CardSuit.Spades:
									foundationPile = this.Authority.CardSupply.GetPile("Foundation3");
									break;
							}
						} else {
							// find matching foundation
							// find empty foundation
							for (var i = 0; i < FreeCellInputInterpreter.TryFoundationPiles.length; i++) {
								var foundationPileStr = FreeCellInputInterpreter.TryFoundationPiles[i];
								foundationPile = this.Authority.CardSupply.GetPile(foundationPileStr);
								if (!foundationPile.Empty &&
									cardClicked.Card.Suit == foundationPile.Top.Suit &&
									cardClicked.Card.ValueNum == foundationPile.Top.ValueNum + 1)
									break;
								foundationPile = null;
							}
						}
						if (foundationPile != null) {
							this.DoMoveCard(cardClicked.Card, cardClicked.Card.Pile, foundationPile, action);
//#if WIN8
							EngineManagers.Sounds.PlaySound("foundation");
//#endif
						} else {
							var emptyFreeCell = null;

							for (var i = 0; i < FreeCellInputInterpreter.TryFreePiles.length; i++) {
								var freePileName = FreeCellInputInterpreter.TryFreePiles[i];
								var freePile = this.Authority.CardSupply.GetPile(freePileName);
								if (freePile.Empty) {
									emptyFreeCell = freePile;
									break;
								}
							}

							if (emptyFreeCell != null) {
								this.DoMoveCard(cardClicked.Card, cardClicked.Card.Pile, emptyFreeCell, action);
//#if WIN8
								if (action.IsAllowed()) {
									EngineManagers.Sounds.PlaySound("legalMove");
									this.ClearHighlight();
								}
//#endif
							}
						}
					} else {
						this._highlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
					}
				} else {
					if (this._highlightedCard != null) {
						var card = this._highlightedCard.Card;
						var fromPile = card.Pile;
						var toPile = cardClicked.Card.Pile;

						if (fromPile != toPile) {
							this.DoMoveCard(card, fromPile, toPile, action);

							if (action.IsAllowed()) {
								this.ClearHighlight();

								// Make the player release mouse button and click again to drag the destination card
								// because immediate dragging after a click move causes shadow and layering bugs.
								cardClicked.IsDragging = cardClicked.SupplyView.IsCardDragging = false;
							} else {
								if (this.Authority.CanPickupCard(cardClicked.Card)) this.HighlightCard(cardClicked);
							}
						} else if (this.Authority.CanPickupCard(cardClicked.Card)) {
							// Select a different card in the same pile.
							this.HighlightCard(cardClicked);
						} else {
							this.Authority.TriggerTip(/* TODO new TipEventArgs("Tips_FreeCell_MoveCards")*/);
						}

//#if WIN8
						if (action.IsAllowed()) {
							EngineManagers.Sounds.PlaySound("legalMove");
						}
//#endif
					}
				}
			} else {
				if (this.Authority.CanPickupCard(cardClicked.Card)) {
					this.HighlightCard(cardClicked);
				} else {
					this.Authority.TriggerTip(/* TODO new TipEventArgs("Tips_FreeCell_MoveCards") */);
				}
			}

			return action;
		};

		FreeCellInputInterpreter.prototype.ClickEmptyPile = function (pileClicked) {
			var supply = pileClicked.Pile.Supply;
			var action = new CardAction(supply);
			action.Parse(["noop"]);

			if (!this.InputEnabled) return action;

			if (this.IsCardHighlighted()) {
				var card = this._highlightedCard.Card;
				var fromPile = card.Pile;
				var toPile = pileClicked.Pile;
				this.DoMoveCard(card, fromPile, toPile, action);
				this.ClearHighlight();
			}

			return action;
		};

		FreeCellInputInterpreter.prototype.ClickOutside = function () {
			this.ClearHighlight();
		};


		FreeCellInputInterpreter.prototype.IsCardHighlighted = function () {
			return (this._highlightedCard != null);
		};

		FreeCellInputInterpreter.prototype.GetHighlightedCard = function () {
			return this._highlightedCard;
		};

		FreeCellInputInterpreter.prototype.HighlightCard = function (card) {
			this._highlightedCard = card;
			this._highlightedCard.Highlight();
			this._highlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
			Debug.log("HighlightCard " + card.Card.toString());
			// notify UI?
		};

		FreeCellInputInterpreter.prototype.ClearHighlight = function () {
			if (this._highlightedCard != null) {
				this._highlightedCard.ClearHighlight();
				this._highlightedCard = null;
				this._highlightTime = -1;
			}
			Debug.log("ClearHighlight()");
			// notify UI?
		};

		FreeCellInputInterpreter.prototype.ShouldMoveKeyboard = function (action, card) {
			return false;
		};

		FreeCellInputInterpreter.prototype.DealNextFromStock = function (supplyView) {

		};

		return FreeCellInputInterpreter;

	});

